import { DEFAULT_IMAGE_SRC, DEFAULT_AVATAR } from "@constants";

const replaceErrorImage = ({ currentTarget }) => {
  currentTarget.onerror = null; // prevents looping
  currentTarget.src = DEFAULT_IMAGE_SRC;
};

const replaceErrorAvatar = ({ currentTarget }) => {
  currentTarget.onerror = null; // prevents looping
  currentTarget.src = DEFAULT_AVATAR;
};

export { replaceErrorImage, replaceErrorAvatar };
